'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';

import {
  Header,
  Footer,
  QueryProvider,
  useAnalyticsConsent,
} from '@j-s/dr-client';

const CookieConsent = dynamic(
  () => import('@j-s/dr-client').then((mod) => mod.CookieConsent),
  { ssr: false },
);

export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith('/admin');

  useAnalyticsConsent();

  return (
    <QueryProvider>
      {isAdmin ? (
        <main className="w-full min-h-screen bg-gray-50">{children}</main>
      ) : (
        <>
          <Header />
          <main className="w-full">{children}</main>
          <Footer />
          <CookieConsent />
        </>
      )}
    </QueryProvider>
  );
}
